import styled, { keyframes } from 'styled-components'
import { m as motion } from 'framer-motion'
import { Section, Title, Description } from './globalStyles'
import { media } from './globalStyles'

const circlingIn = keyframes`
  0% {
    r: 20%;
  }
  50% {
    r: calc(50% - 1px);
  }

  100% {
    r: 30%;
  }
`
const circlingOut = keyframes`
  0% {
    r: 30%;
    opacity: 1;
  }

  100% {
    r: 0;
    opacity: 0;
  }
`

const circling = keyframes`
  0% {
    r: calc(50% - 1px);
  }
  50% {
    r: calc(10%);
  }
  100% {
    r: calc(50% - 1px);
  }
`

export const ServicesSection = styled(Section)`
  color: white;
  z-index: 7;
  .Scroller {
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    padding: 0 11.7862% 0 9%;
    ${media.lessThan('desktop15')`
      padding: 0 10% 0 7.5%;
    `};
    ${media.lessThan('miniTablet')`
      padding: 0 8.5rem 0 3.25rem;
    `};
    ${media.lessThan('phone')`
      padding: 9rem 1.5625rem 0;
    `};
    & > div:last-child {
      background: ${(props) => props.theme.superLightGray};
    }
  }
`

export const ServicesWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  height: auto;
  min-height: 100%;
  padding-left: 2.7862%;
  ${media.lessThan('desktop15')`
    padding-left: 2.5%;
  `};
  ${media.lessThan('miniTablet')`
    padding: 0;
  `};
  ${media.lessThan('phone')`
    display: block;
  `};
`

export const ServicesTitle = styled(Title)`
  text-transform: uppercase;
  margin-bottom: 1rem;
  ${media.lessThan('phone')`
    margin-bottom: 1.5rem;
  `};
`

export const ServicesDescription = styled(Description)`
  max-width: 66%;
  ${media.lessThan('desktop15')`
    max-width: 68%;
  `};
  ${media.lessThan('miniTablet')`
    max-width: none;
    padding-right: 1.5rem;
  `};
  ${media.lessThan('phone')`
    padding: 0;
  `};
  a {
    font-weight: 500;
    color: ${(props) => props.theme.darkBlue};
    ${media.greaterThan('phone')`
      transition: all 300ms;
      transition-property: color;
      will-change: color;
      &:hover {
        color: ${(props) => props.theme.white};
      }
    `}
  }

  .readMoreMobile {
    color: white;
  }
`

export const ServicesLinks = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-top: 6rem;
  ${media.lessThan('miniTablet')`
    flex-flow: column nowrap;
    margin-top: 3.5rem;
  `};
`

export const ServiceLinkButton = styled(motion.button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  color: white;
  margin-right: 5.75rem;
  ${media.lessThan('tablet')`
    margin-right: 4rem;
  `};
  ${media.lessThan('miniTablet')`
    margin: 0 0 3rem;
  `};
  .icon {
    position: relative;
    width: 4.8125rem;
    height: 0;
    padding-top: 4.8125rem;
    margin-right: 1.875rem;
    svg {
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  .text {
    padding-bottom: 0.625rem;
    border-bottom: 3px solid white;
    ${media.greaterThan('phone')`
      transition: all 300ms;
      transition-property: border-color;
      will-change: border-color;
    `}
    span {
      font-size: 1.5625rem;
      line-height: 2.0625rem;
      font-weight: 700;
      text-transform: uppercase;
      margin-right: 0.5rem;
      ${media.greaterThan('phone')`
        transition: all 300ms;
        transition-property: color;
        will-change: color;
      `}
      ${media.lessThan('phone')`
        display: block;
      `};
      &:first-child {
        display: block;
        font-size: 1.25rem;
        line-height: 1.625rem;
      }
      &:last-child {
        margin: 0;
      }
    }
  }
  &:first-child {
    .icon {
      width: 4rem;
      padding-top: 4rem;
      transition: all 300ms linear;
      transition-property: transform;
      will-change: transform;
      ${media.lessThan('phone')`
        width: 5.5rem;
        padding-top: 5.75rem;
      `};
      ${media.lessThan('miniPhone')`
        width: 3.75rem;
        padding-top: 4.25rem;
      `};
      svg {
        width: 100%;
        height: auto;
        path,
        circle {
          transition: transform 500ms ease-out, opacity 500ms ease-out;
          transition-delay: 500ms, 0s;
          will-change: transform;
        }
        path {
          &:first-child {
            opacity: 0;
          }
        }
      }
    }
    &:hover {
      .icon {
        transform: rotate(-180deg);
        transition-delay: 1s;
        svg {
          path:first-child {
            opacity: 1;
            transform: translateY(1.5rem);
            ${media.lessThan('desktop16')`
              transform: translateY(1.625rem);
            `};
            ${media.lessThan('desktop15')`
              transform: translateY(1.8125rem);
            `};
            ${media.lessThan('desktop14')`
              transform: translateY(2rem);
            `};
            ${media.lessThan('desktop13')`
              transform: translateY(2.1875rem);
            `};
          }
        }
      }
    }
    
    ${media.lessThan('phone')`
      .icon {
        svg {
          path:first-child {
            transform: translateY(2rem);
          }
        }
      }
    `};
  }
  &:last-child {
    .icon {
      margin-right: 1.625rem;
      ${media.lessThan('phone')`
        width: 6rem;
        padding-top: 6rem;
      `};
      ${media.lessThan('miniPhone')`
        width: 4.25rem;
        padding-top: 4.25rem;
      `};
      svg {
        width: auto;
        height: 100%;
        g[data-name='fill'] {
          opacity: 0;
          stroke: none;
          fill: ${(props) => props.theme.orange};
          transition: opacity 500ms ease-out;
          transition-delay: 500ms;
          will-change: opacity;
        }
      }
    }
    &:not(:hover) {
      .icon {
        svg {
          g[data-name='fill'] {
            circle:first-child {
              animation: ${circlingOut} 500ms ease-out forwards;
            }
          }
          g[data-name='stroke'] {
            circle:last-child {
              animation: ${circling} 500ms ease-out forwards;
            }
          }
        }
      }
    }
    &:hover {
      .icon {
        svg {
          g[data-name='fill'] {
            opacity: 1;
            transition-delay: 0s;
            circle:first-child {
              animation: ${circlingIn} 1s ease-out forwards;
            }
          }
        }
      }
    }
    ${media.lessThan('tablet')`
      .icon {
        svg {
          g[data-name='fill'] {
            opacity: 1;
            transition-delay: 0s;
            circle:first-child {
              animation: ${circlingIn} 1s ease-out forwards;
            }
          }
        }
      }
    `};
  }
  &:hover {
    .text {
      border-color: ${(props) => props.theme.darkBlue};
      span {
        color: ${(props) => props.theme.darkBlue};
      }
    }
  }
`

export const ServiceModalContainer = styled(Section)`
  position: relative;
  color: black;
  height: calc(var(--vh, 1vh) * 100);
  padding: 1rem 0;
  overflow: hidden;
  .Scroller {
    width: 100%;
    height: 100%;
    padding: 0 10%;
    ${media.lessThan('phone')`
      padding: 0;
    `};
    & > div:last-child {
      background: ${(props) => props.theme.darkBlue};
    }
  }
`

export const ServiceLogoContainer = styled(motion.button)`
  position: relative;
  right: 3rem;
  bottom: -1rem;
  ${media.greaterThan('phone')`
    transition: opacity 1s ease-out;
    &:hover {
      opacity: 0.6;
    }
  `}
  ${media.lessThan('phone')`
    right: 1rem;
  `};
`

export const Accent = styled(motion.div)`
  position: fixed;
  left: 0;
  top: 0;
  width: 25vw;
  width: calc(var(--vw, 1vw) * 25);
  padding-top: 25vw;
  padding-top: calc(var(--vw, 1vw) * 25);
  svg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 50%;
    top: 50%;
    pointer-events: none;
    transform: translate(-50%, -50%) translateZ(0) scale(1.0, 1.0);
  }
`

export const ServiceModalWrapper = styled(motion.div)`
  width: 100%;
  height: auto;
  min-height: calc(var(--vh, 1vh) * 100);
  padding: 5rem 32.2108% 5rem 23.5724%;
  ${media.lessThan('desktop14')`
    padding: 5rem 30% 5rem 20%;
  `};
  ${media.lessThan('tablet')`
    padding: 5rem 20% 5rem 12%;
  `};
  ${media.lessThan('phone')`
    padding: 3rem 5rem 2.5rem 1.5rem;
  `};
`

export const ServiceTitle = styled.div`
  margin-bottom: 1.75rem;
  h3 {
    font-size: 3.8125rem;
    line-height: 3.8125rem;
    text-transform: capitalize;
    margin-bottom: 1rem;
    ${media.lessThan('phone')`
      font-size: 2.1875rem;
      line-height: 1.875rem;
    `}
    span {
      display: inline-block;
      margin-right: 0.875rem;
      &:first-child {
        display: block;
        font-size: 2rem;
        line-height: 2rem;
        ${media.lessThan('phone')`
          font-size: 1.5rem;
          line-height: 1.5rem;
        `}
      }
    }
  }
  p {
    font-size: 1rem;
    line-height: 1.3125rem;
    font-weight: 400;
    ${media.lessThan('desktop15')`
      font-size: 1.125rem;
      line-height: 1.4375rem;
    `};
  }
`

export const ServiceDescription = styled.div`
  p {
    font-size: 1.5rem;
    line-height: 1.8125rem;
    font-weight: 300;
    margin-bottom: 1.75rem;
    &:last-child {
      margin: 0;
    }
  }
`

export const ServiceItems = styled.div`
  padding: 3.75rem 0 0;
`

export const ServiceItem = styled.div`
  font-weight: 300;
  margin-bottom: 2.5rem;
  h4 {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    font-size: 1.6875rem;
    line-height: 1.875rem;
    span {
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      width: 1.5rem;
      height: 1.875rem;
      flex-shrink: 0;
      margin-right: 1rem;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    ${media.lessThan('phone')`
      font-size: 1.75rem;
      line-height: 2rem;
    `}
  }
  &.contentful { 
    h4 {
      font-size: 2.1875rem;
      line-height: 2.375rem;
      cursor: pointer;
      transition: color 300ms linear;
      ${media.lessThan('phone')`
        font-size: 1.75rem;
        line-height: 2rem;
      `}
      &:hover {
        color: ${props => props.theme.blue};
      }
      span {
        width: 2.5rem;
        height: 2.375rem;
      }
    }
    p {
      display: flex;
      flex-flow: row nowrap;
      margin-left: 1rem;
      &::before {
        display: block;
        flex-shrink: 0;
        content: '';
        width: 0.625rem;
        height: 0.625rem;
        margin-top: 0.4375rem;
        margin-right: 1rem;
        border-radius: 50%;
        background: ${props => props.theme.blue};
      }
    }
  }
`

export const ServiceItemDescription = styled(motion.div)`
  overflow: hidden;
  p {
    font-size: 1.125rem;
    line-height: 1.5rem;
    margin-top: 2rem;
  }
`
